// removed by extract-text-webpack-plugin
module.exports = {"full":"comics__full_3xuVY","splitWrapper":"comics__splitWrapper_1IF5y","split":"comics__split_12TWL","viewAll":"comics__viewAll_1nZZM","artistSite":"comics__artistSite_NcGlP","viewAllLink":"comics__viewAllLink_34Y5F","drawingWrapper":"comics__drawingWrapper_2U5Ox","headerImage":"comics__headerImage_NIyoL"};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/comics/styles.less
// module id = ./src/client/components/comics/styles.less
// module chunks = comics